// extracted by mini-css-extract-plugin
export var anchor = "heading-module--anchor--VWYFA";